import React from 'react'
import { Card, useTheme } from '@mui/material'
import { Text } from '@mxenabled/mxui'

import { type Notification } from '../../core'
import { useNotificationStore } from '../../common'
import NotificationBadge from './NotificationBadge'

interface NotificationCardProps {
  notification: Notification
  onClick: (notification: Notification) => void
}

const NotificationCard: React.FC<NotificationCardProps> = ({ notification, onClick }) => {
  const { updateNotification } = useNotificationStore()
  const theme = useTheme()

  const styles = {
    card: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      marginBottom: 12,
      paddingX: 24,
      paddingY: 12,
      '&:focus': {
        backgroundColor: theme.palette.background.default,
      },
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      },
    },
    dot: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: '100%',
      flex: '0 0 auto',
      marginLeft: -8,
      marginRight: 8,
      height: 8,
      width: 8,
    },
  }

  const handleOnClick = () => {
    onClick(notification)
    updateNotification({ ...notification, has_been_viewed: true }).finally()
  }

  return (
    <Card onClick={handleOnClick} sx={styles.card}>
      {!notification.has_been_viewed ? (
        <div data-testid="new-message-dot" style={styles.dot} />
      ) : null}
      <NotificationBadge notification={notification} />
      <Text bold={!notification.has_been_viewed} truncate={false} variant={'body2'}>
        {notification.content}
      </Text>
    </Card>
  )
}

export default NotificationCard
